import { useEffect, useRef } from 'react';
import { libraryService } from '../services/libraryService';

const MIN_CHECK_INTERVAL = 3 * 60 * 1000;

export function useSmartSync() {
  const lastCheck = useRef(0);
  useEffect(() => {
    const check = () => {
      const now = Date.now();
      if (!navigator.onLine || now - lastCheck.current < MIN_CHECK_INTERVAL) return;
      lastCheck.current = now;
      void libraryService.smartSync().catch(() => undefined);
    };
    const onVisibility = () => { if (document.visibilityState === 'visible') check(); };
    check();
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('online', check);
    return () => { document.removeEventListener('visibilitychange', onVisibility); window.removeEventListener('online', check); };
  }, []);
}
